/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UserType = {
    Natural: 'NATURAL',
    Legal: 'LEGAL'
} as const;
export type UserType = typeof UserType[keyof typeof UserType];


export function instanceOfUserType(value: any): boolean {
    for (const key in UserType) {
        if (Object.prototype.hasOwnProperty.call(UserType, key)) {
            // @ts-ignore
            if (UserType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UserTypeFromJSON(json: any): UserType {
    return UserTypeFromJSONTyped(json, false);
}

export function UserTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserType {
    return json as UserType;
}

export function UserTypeToJSON(value?: UserType | null): any {
    return value as any;
}

